import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import Filter from 'views/machine/products2/partners-games/filter'; // Importing Filter component
import Table from 'views/machine/products2/partners-games/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * PartnersGamesView class extends JetView to create a specific view for partners games.
 */
export default class PartnersGamesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration
        const left = {
            rows: [Filter, Table], // Layout containing Filter and Table components
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Type of the view
            view: 'form', // Main view type
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive design identifier
                    type: 'wide', // Type of the column
                    cols: [left], // Columns layout containing the left section
                },
            ],
        };
    }

    /**
     * Initializes the view. Currently empty but can be used for setup tasks.
     */
    init() {}
}

// FILE DOCUMENTED
